// extracted by mini-css-extract-plugin
export var row = "_ty-0";